import React from "react";

const ContactSection = ({ setActiveSection, activeSection }) => {

  // ⭐ Banner should appear ONLY in full Contact Page
  const showBanner = activeSection === "contact";

  return (
    <section id="contact-us" className="bg-gray-50">

      {/* ⭐ PREMIUM BANNER (Same style as About/Gallery) */}
      {showBanner && (
        <div className="relative w-full h-[320px] md:h-[420px]">

          {/* Background */}
          <img
            src="/gallary/g7.jpg"
            alt="Contact Banner"
            className="absolute inset-0 w-full h-full object-cover"
          />

          {/* Dark overlay */}
          <div className="absolute inset-0 bg-black/50"></div>

          {/* CENTER TITLE */}
          <div className="absolute inset-0 flex flex-col items-center justify-center">
            <h1 className="text-4xl md:text-5xl font-bold text-white">
              Contact Us
            </h1>
          </div>

          {/* LEFT BOTTOM TITLE */}
          <div className="absolute bottom-0 left-0 bg-black/40 py-3 px-6">
            <h2 className="text-xl md:text-2xl text-white font-semibold">
              Contact Us
            </h2>
          </div>

          {/* RIGHT BOTTOM BREADCRUMB */}
          <div className="absolute bottom-0 right-0 bg-black/40 py-3 px-6 flex items-center gap-2 text-white">
            <button
              onClick={() => setActiveSection("home")}
              className="hover:text-amber-300 transition"
            >
              Home
            </button>
            <span>›</span>
            <span className="text-amber-300">Contact Us</span>
          </div>
        </div>
      )}

      {/* ⭐ YOUR ORIGINAL CODE STARTS — NOT A SINGLE CHANGE */}
      <section id="contact-us" className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">

          {/* Heading */}
          <h2 className="text-3xl font-bold text-center mb-12 text-[#36676F]">
            Contact Us
          </h2>

          {/* Card Box */}
          <div className="bg-white shadow-xl rounded-xl p-8 grid grid-cols-1 lg:grid-cols-2 gap-10">

            {/* LEFT – Google Map */}
            <div className="w-full h-96 rounded-lg overflow-hidden shadow-md">
              <iframe
                src="https://maps.google.com/maps?width=600&amp;height=400&amp;hl=en&amp;q=AYUSH SPA,4th floor, slv complex, No 3, Kothnur Dinne Main Rd, Nrupathunga Nagar, RBI Layout, JP Nagar 7th Phase, Bengaluru, Karnataka 560078&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"
                width="100%"
                height="100%"
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </div>

            {/* RIGHT – Contact Form */}
            <form className="space-y-5">

              <div>
                <label className="font-medium text-gray-700">Your Name*</label>
                <input
                  type="text"
                  className="w-full mt-1 p-3 border rounded-md focus:outline-[#36676F]"
                  placeholder="Enter your name"
                />
              </div>

              <div>
                <label className="font-medium text-gray-700">Your Email*</label>
                <input
                  type="email"
                  className="w-full mt-1 p-3 border rounded-md focus:outline-[#36676F]"
                  placeholder="Enter your email"
                />
              </div>

              <div>
                <label className="font-medium text-gray-700">Your Phone*</label>
                <input
                  type="tel"
                  className="w-full mt-1 p-3 border rounded-md focus:outline-[#36676F]"
                  placeholder="Enter phone number"
                />
              </div>

              <div>
                <label className="font-medium text-gray-700">Message*</label>
                <textarea
                  rows="4"
                  className="w-full mt-1 p-3 border rounded-md focus:outline-[#36676F]"
                  placeholder="Write your message..."
                ></textarea>
              </div>

              <button
                type="submit"
                className="w-full bg-[#36676F] text-white p-3 rounded-md hover:bg-[#2c5359]"
              >
                Submit
              </button>

            </form>
          </div>
        </div>
      </section>
      {/* ⭐ ORIGINAL CODE ENDS */}

    </section>
  );
};

export default ContactSection;
